import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useStateMachine } from 'little-state-machine'

import { Store } from '../Scale'
import { Label, FieldWrapper } from '../Layout'
import { MAX_LENGTH, CharCounter } from '../CharCounter'

export function Makaton() {
  const { register, setValue, watch } = useFormContext()
  const { t } = useTranslation('translation')

  const makaton = watch()

  const {
    state: { inquery },
  } = useStateMachine<Store>()

  React.useEffect(() => {
    if (inquery.defaultValues['-11'])
      setValue('-11', inquery.defaultValues['-11'])
    if (inquery.defaultValues['-12'])
      setValue('-12', inquery.defaultValues['-12'])
    if (inquery.defaultValues['-13'])
      setValue('-13', inquery.defaultValues['-13'])
    if (inquery.defaultValues['-14'])
      setValue('-14', inquery.defaultValues['-14'])
  }, [inquery.defaultValues])

  return (
    <React.Fragment>
      <FieldWrapper>
        <Label>{t('makaton.title')}</Label>
        <Label htmlFor="makaton-1">
          {t('makaton.1.title')}

          <select id="makaton-1" name="-11" ref={register({ required: 'required' })}>
            <option value="1">{t('options.yes')}</option>
            <option value="2">{t('options.no')}</option>
          </select>
        </Label>
      </FieldWrapper>
      <FieldWrapper>
        <Label htmlFor="makaton-2">
          {t('makaton.2.title')}

          <select id="makaton-2" name="-12" ref={register({ required: 'required' })}>
            <option value="1">{t('options.yes')}</option>
            <option value="2">{t('options.no')}</option>
          </select>
        </Label>
      </FieldWrapper>
      {makaton[-12] === '1' && (
        <FieldWrapper>
          <Label htmlFor="makaton-3">
            {t('makaton.3.title')}

            <select id="makaton-3" name="-13" ref={register({ required: 'required' })}>
              <option value="1">{t('makaton.3.options.1')}</option>
              <option value="2">{t('makaton.3.options.2')}</option>
              <option value="3">{t('makaton.3.options.3')}</option>
              <option value="4">{t('makaton.3.options.4')}</option>
              <option value="5">{t('makaton.3.options.5')}</option>
            </select>
          </Label>
        </FieldWrapper>
      )}
      {makaton[-12] === '1' && makaton[-13] === '5' && (
        <FieldWrapper>
          <Label>
            {t('makaton.4.title')}
            <textarea
              name="-14"
              ref={register({ required: 'required' })}
              maxLength={MAX_LENGTH}
            />
          </Label>
          <CharCounter length={makaton[-14]?.length} />
        </FieldWrapper>
      )}
    </React.Fragment>
  )
}
